export const resolveCoverageName = coverageId => {
    let name = '';
    switch (coverageId) {
        case 1018:
            name = 'Lagom';
            break;
        case 1019:
            name = 'Bas';
            break;
        case 1020:
            name = 'Plus';
            break;
    }
    return name;
};
